(function () {
  // --- Google Form sink for game suggestions ---
  var SUGGEST = {
    action: 'https://docs.google.com/forms/d/e/1FAIpQLSfJBaNjtZQRQ2K4SQx-Pjg9MHfwq7PWohFdmtzirozu2P3-5A/formResponse',
    game: 'entry.2139070487',
    console: 'entry.851289596',
    term: 'entry.726231779',
    page: 'entry.850399791'
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function nf(n) { return n.toLocaleString('en-US'); }

  ready(function () {
    var root = document.getElementById('g11-root');
    if (!root) return;
    if (!window.G11_GAMES || !window.G11_CONSOLES) {
      root.innerHTML = '<p style="text-align:center;color:#c00;">Could not load the games list. Please refresh the page.</p>';
      return;
    }
    var CONS = window.G11_CONSOLES;
    var GAMES = window.G11_GAMES;
    var DISPLAY_TOTAL = 50407; // marketing count shown in the search placeholder (real count = GAMES.length)
    var HANDLE = window.G11_HANDLE;
    var INDEX = window.G11_INDEX_HANDLE;

    // suggestion card markup (hidden until opened)
    function suggestCardHTML() {
      return '' +
        '<p class="g11-suggest-link"><a href="#" class="g11-suggest-open" data-term="">Can\'t find a game? Suggest it →</a></p>' +
        '<div id="g11-suggest" class="g11-suggest" hidden>' +
        '  <h3>Suggest a game</h3>' +
        '  <p>Not on the list? Tell us and we may add it to the G11 Pro.</p>' +
        '  <form id="g11-s-form" novalidate>' +
        '    <input type="text" id="g11-s-game" placeholder="Game name" autocomplete="off">' +
        '    <input type="text" id="g11-s-console" placeholder="Console (if known)" autocomplete="off">' +
        '    <input type="text" id="g11-s-hp" class="g11-hp" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '    <button type="submit" id="g11-s-btn">Send suggestion</button>' +
        '    <div class="g11-s-status" id="g11-s-status" aria-live="polite"></div>' +
        '  </form>' +
        '</div>';
    }

    function wireSuggest(consoleLabel) {
      var box = document.getElementById('g11-suggest');
      var form = document.getElementById('g11-s-form');
      var gameI = document.getElementById('g11-s-game');
      var consI = document.getElementById('g11-s-console');
      var hpI = document.getElementById('g11-s-hp');
      var btn = document.getElementById('g11-s-btn');
      var status = document.getElementById('g11-s-status');

      // open triggers (delegated so it works for links rendered later)
      root.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('.g11-suggest-open') : null;
        if (!a) return;
        e.preventDefault();
        var term = a.getAttribute('data-term') || '';
        box.hidden = false;
        status.textContent = '';
        btn.disabled = false;
        gameI.value = term;
        consI.value = consoleLabel || '';
        form.dataset.term = term;
        try { gameI.focus(); } catch (er) {}
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (hpI.value) { done(); return; } // honeypot: bot filled it
        var game = gameI.value.trim();
        if (!game) { status.textContent = 'Please enter a game name.'; status.className = 'g11-s-status g11-s-err'; gameI.focus(); return; }
        btn.disabled = true;
        status.textContent = 'Sending…'; status.className = 'g11-s-status';
        var body = new URLSearchParams();
        body.append(SUGGEST.game, game);
        body.append(SUGGEST.console, consI.value.trim());
        body.append(SUGGEST.term, form.dataset.term || '');
        body.append(SUGGEST.page, location.pathname);
        fetch(SUGGEST.action, {
          method: 'POST', mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        }).then(done).catch(done);
      });

      function done() {
        status.textContent = '✅ Thanks! Your suggestion has been sent.';
        status.className = 'g11-s-status g11-s-ok';
        form.reset();
        btn.disabled = false;
      }
    }

    // accent-insensitive matching ("pokemon" finds "Pokémon")
    function fold(str) {
      return str.normalize ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() : str.toLowerCase();
    }

    // ?q=... in the URL (e.g. from the homepage "Find your childhood game" section) pre-fills the search
    function initialQuery() {
      try { return (new URLSearchParams(location.search).get('q') || '').trim().slice(0, 100); } catch (e) { return ''; }
    }
    function applyInitialQuery(q) {
      var v = initialQuery();
      if (!v) return false;
      q.value = v;
      q.dispatchEvent(new Event('input'));
      return true;
    }

    if (HANDLE === INDEX) renderIndex();
    else renderConsole();

    function renderIndex() {
      root.innerHTML =
        '<div class="g11-searchbar"><input type="text" id="g11-q" placeholder="Search all ' + nf(DISPLAY_TOTAL) + ' games…" autocomplete="off" spellcheck="false"></div>' +
        '<div id="g11-count" class="g11-count"></div>' +
        '<ul id="g11-results" class="g11-list"></ul>' +
        suggestCardHTML() +
        '<h2 class="g11-sub">Or browse by console</h2>' +
        '<div class="g11-grid" id="g11-grid"></div>';

      var grid = document.getElementById('g11-grid');
      var gh = '';
      for (var i = 0; i < CONS.length; i++) gh += '<a href="/pages/' + CONS[i][0] + '">' + esc(CONS[i][1]) + '</a>';
      grid.innerHTML = gh;

      var LC = new Array(GAMES.length);
      for (var k = 0; k < GAMES.length; k++) LC[k] = fold(GAMES[k][0]);

      var q = document.getElementById('g11-q');
      var results = document.getElementById('g11-results');
      var countEl = document.getElementById('g11-count');
      var LIMIT = 300, t;

      function run() {
        var raw = q.value.trim();
        var term = fold(raw);
        if (!term) { results.innerHTML = ''; countEl.textContent = ''; return; }
        var out = [], n = 0;
        for (var i = 0; i < GAMES.length; i++) {
          if (LC[i].indexOf(term) > -1) {
            n++;
            if (out.length < LIMIT) {
              var c = CONS[GAMES[i][1]];
              out.push('<li><span class="g11-name">' + esc(GAMES[i][0]) + '</span><a class="g11-tag" href="/pages/' + c[0] + '">' + esc(c[1]) + '</a></li>');
            }
          }
        }
        results.innerHTML = out.join('');
        if (n === 0) {
          countEl.innerHTML = 'No game found for “' + esc(raw) + '” — <a href="#" class="g11-suggest-open" data-term="' + esc(raw) + '">Suggest it →</a>';
        } else {
          countEl.textContent = nf(n) + ' result' + (n > 1 ? 's' : '') + (n > LIMIT ? ' — showing first ' + LIMIT + ', refine your search' : '');
        }
      }
      q.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 120); });
      // keep the persistent "Suggest it" link seeded with the current query
      q.addEventListener('input', function () {
        var a = root.querySelector('.g11-suggest-link .g11-suggest-open');
        if (a) a.setAttribute('data-term', q.value.trim());
      });
      wireSuggest('');
      if (!applyInitialQuery(q)) { try { q.focus(); } catch (e) {} }
    }

    function renderConsole() {
      var idx = -1;
      for (var i = 0; i < CONS.length; i++) if (CONS[i][0] === HANDLE) { idx = i; break; }
      if (idx < 0) {
        root.innerHTML = '<p style="text-align:center;">This console list is not available. <a href="/pages/' + INDEX + '">See all consoles</a>.</p>';
        return;
      }
      var label = CONS[idx][1];
      var names = [];
      for (var j = 0; j < GAMES.length; j++) if (GAMES[j][1] === idx) names.push(GAMES[j][0]);

      root.innerHTML =
        '<p class="g11-back"><a href="/pages/' + INDEX + '">← All consoles</a></p>' +
        '<div class="g11-searchbar"><input type="text" id="g11-q" placeholder="Search ' + nf(names.length) + ' ' + esc(label) + ' games…" autocomplete="off" spellcheck="false"></div>' +
        '<div id="g11-count" class="g11-count"></div>' +
        '<ul id="g11-results" class="g11-list"></ul>' +
        suggestCardHTML();

      var results = document.getElementById('g11-results');
      var countEl = document.getElementById('g11-count');
      var items = names.map(function (nm) { return '<li><span class="g11-name">' + esc(nm) + '</span></li>'; });
      var lc = names.map(function (nm) { return fold(nm); });
      results.innerHTML = items.join('');

      var q = document.getElementById('g11-q'), t;
      q.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var raw = q.value.trim();
          var term = fold(raw);
          var a = root.querySelector('.g11-suggest-link .g11-suggest-open');
          if (a) a.setAttribute('data-term', raw);
          if (!term) { results.innerHTML = items.join(''); countEl.textContent = ''; return; }
          var out = [];
          for (var i = 0; i < lc.length; i++) if (lc[i].indexOf(term) > -1) out.push(items[i]);
          results.innerHTML = out.join('');
          if (out.length === 0) {
            countEl.innerHTML = 'No ' + esc(label) + ' game found for “' + esc(raw) + '” — <a href="#" class="g11-suggest-open" data-term="' + esc(raw) + '">Suggest it →</a>';
          } else { countEl.textContent = ''; }
        }, 100);
      });
      wireSuggest(label);
      applyInitialQuery(q);
    }
  });
})();
